<template>
	<div>
		<el-row class="margin-top-lg">


			<el-col :span="23" class="text-right">

				<el-button type="primary" size="small" v-if="hasPrivilege('502020082314267912')"
					@click="openBatchPayRoomFeeModal">
					<i class="el-icon-plus"></i>
					缴费
				</el-button>
				<el-button type="primary" size="small" v-if="hasPrivilege('502022073096990007')"
					@click="openRoomCreateFeeAddModal">
					<i class="el-icon-plus"></i>
					{{ $t('simplifyRoomFee.createFee') }}
				</el-button>
				<el-button type="primary" size="small" @click="toOwnerPayFee">
					<i class="el-icon-plus"></i>
					{{ $t('simplifyRoomFee.arrearsPayment') }}
				</el-button>
			</el-col>
		</el-row>


		<div style="text-align: left;">
			<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
				全选/取消全选
			</el-checkbox>
			<span style="margin-left: 20px; color: #666;">
				已选择 {{ multipleSelection.length }} 个月份
			</span>
		</div>
		<div class="margin-top" v-show="simplifyRoomFeeInfo.showFlag == 'MONTH'">

			<el-checkbox-group v-model="multipleSelection" @change="handleMonthSelectionChange">

				<div v-for="(monthData, month) in simplifyRoomFeeInfo.monthFees" :key="month" class="month-section">
					<div style="height: 30px; background-color:antiquewhite;text-align: left; font-size: 15px ;">
						<el-checkbox size="medium" style="height: 17px; width: 17px;font-size: 18px;" :label="month"
							:value="month" :disabled="isMonthDisabled(month)" class="box"></el-checkbox>

						<label style="padding-left: 30px;">(共 {{ monthData.length }} 条记录,
							合计金额(元)：{{ getMonthTotal(monthData) }} 元)</label>
					</div>
					<el-table :data="monthData" :summary-method="getSummaries" show-summary style="width: 100%;" border
						stripe>

						<el-table-column prop="feeName" :label="$t('simplifyRoomFee.feeItem')" align="center">
							<template slot-scope="scope">
								<span class="hand" @click="viewRoomFeeConfig(scope.row)">
									{{ scope.row.feeName }}{{ getSimplifyRoomFeeRoomName(scope.row) }}
								</span>
							</template>
						</el-table-column>
						<el-table-column prop="feeFlagName" :label="$t('simplifyRoomFee.feeFlag')"
							align="center"></el-table-column>
						<el-table-column prop="feeTypeCdName" :label="$t('simplifyRoomFee.feeType')"
							align="center"></el-table-column>
						<el-table-column :label="$t('simplifyRoomFee.chargeYearMonth')" align="center">
							<template slot-scope="scope">
								{{ scope.row.detailYear }}-{{ scope.row.detailMonth }}
							</template>
						</el-table-column>
						<el-table-column prop="receivableAmount" :label="$t('simplifyRoomFee.receivableAmount')"
							align="center"></el-table-column>
						<el-table-column :label="$t('simplifyRoomFee.description')" align="center" width="150">
							<template slot-scope="scope">
								<div
									v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
									<span>{{ $t('simplifyRoomFee.preDegrees') }}</span>{{ scope.row.preDegrees }}
								</div>
								<div
									v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
									<span>{{ $t('simplifyRoomFee.curDegrees') }}</span>{{ scope.row.curDegrees }}
								</div>
								<div
									v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
									<span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ getOnePrice1(scope.row) }}
								</div>
								<div
									v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
									<span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
								</div>
								<div v-else-if="scope.row.computingFormula == '6006'">
									<span>{{ $t('simplifyRoomFee.usage') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390006') }}
								</div>
								<div v-else-if="scope.row.computingFormula == '6006'">
									<span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ scope.row.squarePrice }}
								</div>
								<div v-else-if="scope.row.computingFormula == '6006'">
									<span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
								</div>
								<div v-else-if="scope.row.feeTypeCd == '888800010017'">
									<span>{{ $t('simplifyRoomFee.algorithm') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390005') }}
								</div>
								<div v-else-if="scope.row.feeTypeCd == '888800010017'">
									<span>{{ $t('simplifyRoomFee.usage') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390003') }}
								</div>
								<div v-else>
									<span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ scope.row.squarePrice }}
								</div>
								<div v-if="scope.row.feeFlag == '1003006'">
									<span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
								</div>
								<div v-else>
									<span>{{ $t('simplifyRoomFee.fixedFee') }}</span>{{ scope.row.additionalAmount }}
								</div>
							</template>
						</el-table-column>

						<el-table-column :label="$t('simplifyRoomFee.operation')" align="center" width="200">
							<template slot-scope="scope">

								<el-button type="text" @click="payFeeHis(scope.row)">
									{{ $t('simplifyRoomFee.paymentHistory') }}
								</el-button>
								<el-dropdown
									v-if="hasPrivilege('502020090604200029') || hasPrivilege('502021070488970005') || hasPrivilege('502020090427190001')">
									<span class="el-dropdown-link">
										{{ $t('simplifyRoomFee.moreOperations') }}<i
											class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item v-if="hasPrivilege('502020090604200029')"
											@click.native="deleteFee(scope.row)">
											{{ $t('simplifyRoomFee.cancelFee') }}
										</el-dropdown-item>
            <el-dropdown-item v-if="hasPrivilege('502021070488970005')" @click.native="finishFee(scope.row)">
                  {{ $t('simplifyRoomFee.manualEnd') }}
                </el-dropdown-item>

										
										<el-dropdown-item>
											<a target="_blank"
												:href="'/#/views/fee/feeDetail?feeId=' + scope.row.feeId">
												{{ $t('simplifyRoomFee.details') }}
											</a>
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-checkbox-group>
		</div>

		<el-row>
			<el-col :span="12" class="text-left table-desc">
				<div>{{ $t('simplifyRoomFee.note1') }}</div>
				<div>{{ $t('simplifyRoomFee.note2') }}</div>
			</el-col>
			<el-col :span="6">
				<span>
					<span>小计：</span>{{ simplifyRoomFeeInfo.totalAmount }}
				</span>
			</el-col>
		</el-row>
		<!-- Modal Components -->
		<delete-fee ref="deleteFee" @success="handleNotify"></delete-fee>
		<edit-fee ref="editFee" @success="handleNotify"></edit-fee>
		<temp-import-room-fee ref="tempImportRoomFee" @success="handleNotify"></temp-import-room-fee>
		<room-create-fee-add ref="roomCreateFeeAdd" @success="handleNotify"></room-create-fee-add>
		<add-meter-water ref="addMeterWater" @success="handleNotify"></add-meter-water>
		<add-proxy-fee ref="addProxyFee" @success="handleNotify"></add-proxy-fee>
		<finish-fee ref="finishFee" @success="handleNotify"></finish-fee>
	</div>
</template>


<script>
	import {
		listFee,
		listFeeConfigs,
		listMonthFee,
		groupByYearMonthWithMap
	} from '@/api/fee/simplifyRoomFeeApi'
	import {
		getDict
	} from '@/api/community/communityApi'
	import {
		getCommunityId
	} from '@/api/community/communityApi'
	import TempImportRoomFee from './tempImportRoomFee'
	import {
		dateFormat
	} from '@/utils/dateUtil'
	import DeleteFee from '@/components/fee/deleteFee'
	import EditFee from '@/components/fee/editFee'
	import RoomCreateFeeAdd from '@/components/fee/roomCreateFeeAdd'
	import AddMeterWater from '@/components/fee/addMeterWater'
	import AddProxyFee from '@/components/fee/addProxyFee'
	import FinishFee from '@/components/fee/finishFee'

	export default {
		name: 'SimplifyRoomFee',
		components: {
			TempImportRoomFee,
			DeleteFee,
			EditFee,
			RoomCreateFeeAdd,
			AddMeterWater,
			AddProxyFee,
			FinishFee
		},
		data() {
			return {
				simplifyRoomFeeInfo: {
					total: 0,
					records: 1,
					fees: [],
					monthFees: [],
					roomId: '',
					roomName: '',
					name: '',
					floorNum: '',
					unitNum: '',
					roomNum: '',
					configId: '',
					feeTypeCds: [],
					feeTypeCd: '',
					state: '2008001',
					totalAmount: 0.0,
					roomType: '',
					ownerFee: 'N',
					ownerId: '',
					showFlag: 'MONTH',
					feeConfigs: [],
					haveHistory: false
				},

				currentPage: 1,
				pageSize: 24,
				total: 0,
				multipleSelection: [],
				checkAll: false,
				isIndeterminate: false,
				autoSelectedMonths: []

			}
		},
		computed: {
			filteredFeeTypeCds() {
				return this.simplifyRoomFeeInfo.feeTypeCds.filter(item => item.statusCd !== '888800010008')
			},
			availableMonths() {
				if (!this.simplifyRoomFeeInfo.monthFees) {
					return [];
				}
				return Object.keys(this.simplifyRoomFeeInfo.monthFees);
			},
			sortedAvailableMonths() {
				return [...this.availableMonths].sort((a, b) => {
					const [y1, m1] = a.split('-').map(Number);
					const [y2, m2] = b.split('-').map(Number);
					return y1 * 100 + m1 - (y2 * 100 + m2);
				});
			}
		},

		methods: {
			// ===== 新增：数组相等判断（防止重复赋值触发循环）=====
			arraysEqual(a, b) {
				if (a.length !== b.length) return false;
				for (let i = 0; i < a.length; i++) {
					if (a[i] !== b[i]) return false;
				}
				return true;
			},

			open(params) {
				this.handleSwitch(params)
			},

			getMonthTotal(monthData) {
				if (!monthData || !Array.isArray(monthData)) {
					return '0.00';
				}
				const total = monthData.reduce((sum, item) => {
					const amount = parseFloat(item.receivableAmount) || 0;
					return sum + amount;
				}, 0);
				return total.toFixed(2);
			},

			// 全选 / 取消全选
			handleCheckAllChange(checked) {
				this.multipleSelection = checked ? [...this.sortedAvailableMonths] : [];
				this.isIndeterminate = false;
				// 注意：checkAll 由 v-model 自动更新，无需手动设 this.checkAll
			},

			// 月份选择变化（核心逻辑）
			handleMonthSelectionChange(newVal) {
				const sorted = this.sortedAvailableMonths;
				if (sorted.length === 0) {
					this.multipleSelection = [];
					this.checkAll = false;
					this.isIndeterminate = false;
					return;
				}

				// 找出当前选中的最晚月份索引
				let maxIndex = -1;
				for (let i = 0; i < sorted.length; i++) {
					if (newVal.includes(sorted[i])) {
						maxIndex = i;
					}
				}

				let newSelection;
				if (maxIndex === -1) {
					newSelection = [];
				} else {
					newSelection = sorted.slice(0, maxIndex + 1);
				}

				// 避免不必要的赋值（防止 @change 被反复触发）
				if (!this.arraysEqual(this.multipleSelection, newSelection)) {
					this.multipleSelection = newSelection;
				}

				// 同步全选状态
				const selectedCount = this.multipleSelection.length;
				const totalCount = sorted.length;
				this.checkAll = selectedCount === totalCount;
				this.isIndeterminate = selectedCount > 0 && selectedCount < totalCount;
			},

			getSelectedMonthData() {
				const selectedData = [];
				this.multipleSelection.forEach(month => {
					if (this.simplifyRoomFeeInfo.monthFees[month]) {
						selectedData.push({
							month: month,
							data: this.simplifyRoomFeeInfo.monthFees[month],
							total: this.getMonthTotal(this.simplifyRoomFeeInfo.monthFees[month])
						});
					}
				});
				return selectedData;
			},

			handleSwitch(param) {
				this.clearSimplifyRoomFeeInfo()
				if (param.roomId === '') return

				Object.assign(this.simplifyRoomFeeInfo, param)
				this.listSimplifyRoomMonthFee(1, this.pageSize)

				getDict('pay_fee_config', 'fee_type_cd').then(data => {
					this.simplifyRoomFeeInfo.feeTypeCds = data
				})
			},
			handleNotify() {
				this.listSimplifyRoomMonthFee(this.currentPage, this.pageSize)
			},
			getOnePrice1(fee) {
				let price = fee.mwPrice
				if (!price) return fee.squarePrice
				if (parseFloat(price) > 0) return price
				return fee.squarePrice
			},
			async listSimplifyRoomFee(page, row) {
				const params = {
					page,
					row,
					communityId: getCommunityId(),
					payerObjId: this.simplifyRoomFeeInfo.roomId,
					payerObjType: '3333',
					configId: this.simplifyRoomFeeInfo.configId,
					state: this.simplifyRoomFeeInfo.state,
					feeTypeCd: this.simplifyRoomFeeInfo.feeTypeCd
				}

				if (this.simplifyRoomFeeInfo.ownerFee === 'Y') {
					params.payerObjId = ''
					params.ownerId = this.simplifyRoomFeeInfo.ownerId
				}

				try {
					const res = await listFee(params)
					this.simplifyRoomFeeInfo.total = res.total
					this.simplifyRoomFeeInfo.records = res.records
					let totalAmount = 0.0

					res.fees.forEach(item => {
						totalAmount += parseFloat(item.amountOwed)
					})

					this.simplifyRoomFeeInfo.totalAmount = totalAmount.toFixed(2)
					this.simplifyRoomFeeInfo.fees = res.fees.sort(this.roomFeeCompare)
					this.total = res.total
				} catch (error) {
					console.error('Failed to fetch fee list:', error)
				}
			},
			roomFeeCompare(a, b) {
				if (a.payerObjName < b.payerObjName) return -1
				if (a.payerObjName > b.payerObjName) return 1
				return 0
			},
			toOwnerPayFee() {
				this.$router.push({
					path: '/views/fee/owePayFeeOrder',
					query: {
						payObjId: this.simplifyRoomFeeInfo.roomId,
						payObjType: '3333',
						roomName: this.simplifyRoomFeeInfo.roomName
					}
				})
			},
			openRoomCreateFeeAddModal() {
				this.simplifyRoomFeeInfo.ownerName = this.simplifyRoomFeeInfo.name
				this.$refs.roomCreateFeeAdd.open({
					isMore: false,
					roomId: this.simplifyRoomFeeInfo.roomId,
					roomName: this.simplifyRoomFeeInfo.roomName,
					ownerName: this.simplifyRoomFeeInfo.name
				})
			},
			openAddMeterWaterSimplifyModal() {
				this.$refs.addMeterWater.open({
					roomId: this.simplifyRoomFeeInfo.roomId,
					roomName: this.simplifyRoomFeeInfo.roomName,
					ownerName: this.simplifyRoomFeeInfo.name
				});
			},
			getAttrValue(attrs, specCd) {
				const attr = attrs.find(item => item.specCd === specCd)
				return attr ? attr.value : ""
			},
			getDeadlineTime(fee) {
				if (fee.amountOwed == 0 && fee.endTime == fee.deadlineTime) return "-"
				if (fee.state == '2009001') return "-"
				return dateFormat(fee.deadlineTime)
			},
			getEndTime(fee) {
				if (fee.state == '2009001') return "-"
				return dateFormat(fee.endTime)
			},
			openProxyFeeModal() {
				this.$refs.addProxyFee.open({
					roomId: this.simplifyRoomFeeInfo.roomId,
					roomName: this.simplifyRoomFeeInfo.roomName,
					ownerName: this.simplifyRoomFeeInfo.name
				})
			},
			payFee(fee) {
				fee.roomName = this.simplifyRoomFeeInfo.roomName
				fee.builtUpArea = this.simplifyRoomFeeInfo.builtUpArea
				this.$router.push({
					path: '/views/fee/payFeeOrder',
					query: {
						feeId: fee.feeId
					}
				})
			},
			editFee(fee) {
				fee.maxEndTime = this.getAttrValue(fee.feeAttrs, '390010')
				this.$refs.editFee.open(fee)
			},
			payFeeHis(fee) {
				fee.builtUpArea = this.simplifyRoomFeeInfo.builtUpArea
				this.$router.push({
					path: '/views/fee/propertyFee',
					query: fee
				})
			},
			deleteFee(fee) {
				this.$refs.deleteFee.open({
					communityId: getCommunityId(),
					feeId: fee.feeId
				})
			},
			finishFee(fee) {
				this.$refs.finishFee.open({
					communityId: getCommunityId(),
					feeId: fee.feeId
				})
			},
			openTempImportRoomFeeModal() {
				this.$refs.tempImportRoomFee.open({
					roomId: this.simplifyRoomFeeInfo.roomId,
					roomName: this.simplifyRoomFeeInfo.roomName,
					ownerName: this.simplifyRoomFeeInfo.name
				})
			},
			clearSimplifyRoomFeeInfo() {
				const feeConfigs = this.simplifyRoomFeeInfo.feeConfigs
				this.simplifyRoomFeeInfo = {
					total: 0,
					records: 1,
					fees: [],
					monthFees: [],
					accounts: [],
					roomId: '',
					name: '',
					roomName: '',
					floorNum: '',
					unitNum: '',
					roomNum: '',
					feeConfigs: feeConfigs,
					feeTypeCd: '',
					configId: '',
					state: '2008001',
					totalAmount: 0.0,
					roomType: '',
					ownerFee: 'N',
					ownerId: '',
					showFlag: 'MONTH'
				}
			},
			changeSimplifyRoomFeeFeeTypeCd(feeTypeCd) {
				this.simplifyRoomFeeInfo.configId = ''
				this.$emit('notify', {})

				const params = {
					page: 1,
					row: 50,
					communityId: getCommunityId(),
					feeTypeCd: feeTypeCd,
					isDefault: '',
					valid: '1'
				}

				listFeeConfigs(params).then(res => {
					this.simplifyRoomFeeInfo.feeConfigs = res.feeConfigs
				}).catch(error => {
					console.error('Failed to fetch fee configs:', error)
				})
			},
			changeSimplifyRoomConfigId() {
				this.$emit('notify', {})
			},
			simplifyRoomGetFeeOwnerInfo(attrs) {
				const ownerName = this.getAttrValue(attrs, '390008')
				const ownerLink = this.getAttrValue(attrs, '390009')
				return `业主：${ownerName},电话：${ownerLink}`
			},
			getSimplifyRoomFeeRoomName(fee) {
				if (this.simplifyRoomFeeInfo.ownerFee != 'Y') return ''

				const attr = fee.feeAttrs.find(item => item.specCd === '390012')
				return attr ? `(${attr.value})` : ''
			},
			openBatchPayRoomFeeModal() {
				if (this.haveHistory) {
					alert("该用户存在历史性欠费，请先缴清历史性欠费。");
					this.toOwnerPayFee();
					return;
				}

				// ✅ 统计 feeId 出现次数
				const feeIdCountMap = {};

				this.multipleSelection.forEach(month => {
					const monthData = this.simplifyRoomFeeInfo.monthFees[month];
					if (Array.isArray(monthData)) {
						monthData.forEach(item => {
							if (item.feeId) {
								feeIdCountMap[item.feeId] = (feeIdCountMap[item.feeId] || 0) + 1;
							}
						});
					}
				});

				// 转为数组格式（可选，便于传输或展示）
				const feeIdCountList = Object.entries(feeIdCountMap).map(([feeId, count]) => ({
					feeId,
					count
				}));

				if (feeIdCountList.length === 0) {
					this.$message.warning('请至少选择一个月份进行缴费');
					return;
				}

				// ✅ 方案：通过 sessionStorage 传递（避免 URL 过长 + 支持复杂结构）
				sessionStorage.setItem('batchPayFeeIdCounts', JSON.stringify(feeIdCountList));

				this.$router.push({
					path: '/views/fee/batchPayFeeOrder',
					query: {
						ownerId: this.simplifyRoomFeeInfo.ownerId,
						payerObjType: '3333'
					}
				});
			},
			openMonthPayRoomFeeModal() {
				this.$router.push({
					path: '/property/payFeeMonthOrder',
					query: {
						payerObjId: this.simplifyRoomFeeInfo.roomId,
						payerObjType: '3333'
					}
				})
			},
			openRoomCreateFeeComboModal() {
				this.$router.push({
					path: '/views/fee/createFeeByCombo',
					query: {
						payerObjId: this.simplifyRoomFeeInfo.roomId,
						payerObjName: this.simplifyRoomFeeInfo.roomName,
						payerObjType: '3333'
					}
				})
			},
			viewRoomFeeConfig(fee) {
				const params = {
					page: 1,
					row: 1,
					communityId: getCommunityId(),
					configId: fee.configId
				}

				listFeeConfigs(params).then(res => {
					const feeConfig = res.feeConfigs[0]
					this.$emit('openViewDataModal', {
						title: `${fee.feeName} 费用项`,
						data: {
							"费用项ID": feeConfig.configId,
							"费用类型": feeConfig.feeTypeCdName,
							"收费项目": feeConfig.feeName,
							"费用标识": feeConfig.feeFlagName,
							"催缴类型": feeConfig.billTypeName,
							"付费类型": feeConfig.paymentCd == '1200' ? '预付费' : '后付费',
							"缴费周期": feeConfig.paymentCycle,
							"应收开始时间": feeConfig.startTime,
							"应收结束时间": feeConfig.endTime,
							"公式": feeConfig.computingFormulaName,
							"计费单价": feeConfig.computingFormula == '2002' ? '-' : feeConfig.squarePrice,
							"附加/固定费用": feeConfig.additionalAmount
						}
					})
				}).catch(error => {
					console.error('Failed to fetch fee config:', error)
				})
			},
			viewRoomFee(fee) {
				const data = {
					"费用ID": fee.feeId,
					"费用标识": fee.feeFlagName,
					"费用类型": fee.feeTypeCdName,
					"付费对象": fee.payerObjName,
					"费用项": fee.feeName,
					"费用状态": fee.stateName,
					"建账时间": fee.startTime,
					"应收开始时间": this.getEndTime(fee),
					"应收结束时间": this.getDeadlineTime(fee),
					"批次": fee.batchId
				}

				fee.feeAttrs.forEach(attr => {
					data[attr.specCdName] = attr.value
				})

				this.$emit('openViewDataModal', {
					title: `${fee.feeName} 详情`,
					data: data
				})
			},
			changeSimplifyRoomShowFlag() {
				if (this.simplifyRoomFeeInfo.showFlag == 'MONTH') {
					this.listSimplifyRoomMonthFee(1, this.pageSize)
				} else {
					this.listSimplifyRoomFee(1, this.pageSize)
				}
			},
			async listSimplifyRoomMonthFee(page, row) {
				const params = {
					page,
					row,
					communityId: getCommunityId(),
					objId: this.simplifyRoomFeeInfo.roomId,
					payerObjType: '3333',
					configId: this.simplifyRoomFeeInfo.configId,
					feeTypeCd: this.simplifyRoomFeeInfo.feeTypeCd,
					detailId: '-1',
					feeState: '2008001'
				}

				if (this.simplifyRoomFeeInfo.ownerFee == 'Y') {
					params.payerObjId = ''
					params.ownerId = this.simplifyRoomFeeInfo.ownerId
				}

				try {
					const res = await listMonthFee(params)
					this.simplifyRoomFeeInfo.total = res.total
					this.simplifyRoomFeeInfo.records = res.records
					let totalAmount = 0.0
					this.haveHistory = false; // 重置历史欠费标志
					res.data.forEach(item => {
						totalAmount += parseFloat(item.receivableAmount)
						if (item.remark == '历史费用') {
							this.haveHistory = true;
						}
					})
					this.simplifyRoomFeeInfo.totalAmount = totalAmount.toFixed(2)
					this.simplifyRoomFeeInfo.monthFees = groupByYearMonthWithMap(res.data)
				} catch (error) {
					console.error('Failed to fetch month fee list:', error)
				}
			},
			handleCurrentChange(page) {
				this.currentPage = page
				if (this.simplifyRoomFeeInfo.showFlag == 'MONTH') {
					this.listSimplifyRoomMonthFee(page, this.pageSize)
				} else {
					this.listSimplifyRoomFee(page, this.pageSize)
				}
			},
			parseYearMonth(ym) {
				if (!ym || typeof ym !== 'string') return 0;
				const [year, month] = ym.split('-').map(Number);
				return year * 100 + month;
			},
			isMonthDisabled(month) {
				return this.autoSelectedMonths.includes(month) && this.multipleSelection.length > 0;
			}
		}
	}
</script>

<style scoped>
	.margin-top-lg {
		margin-top: 20px;
	}

	.margin-top {
		margin-top: 15px;
	}

	.text-right {
		text-align: right;
	}

	.hand {
		cursor: pointer;
	}
</style>